export class AssessmentDto {
    id?: string;
    assessmentName?: String;
    assessmentType?: String;
    noOfQuestions?: number;
    assessmentDuration?: number;
    assessmentWindowDuration?: number;
    date?: string;
}

export class StopCodeServerDto {
    question_id: string;
    candidate_id: string;
    userAssessmentDriveSetId: string;
    driveId: string;
    container_name: string;
}